export default "__VITE_ASSET__sj0Tph4e__"